
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Linear": () => {
return Promise.all(/*  | __federation_expose_Linear */ [__webpack_require__.e("558"), __webpack_require__.e("161"), __webpack_require__.e("325"), __webpack_require__.e("912")]).then(() => (() => (__webpack_require__(491))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };